module.exports = __webpack_public_path__ + "static/media/TasklyCustomerExperienceMap.4cb6fadf.png";